import KeyPointIndicatorListView from "./KeyPointIndicatorListView";

import "./KeyPointIndicatorListView.scss";

export { KeyPointIndicatorListView };
